// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-user{ margin: 130px 80px 100px 80px; }


.dashboard-user section{ margin: 0px; }

.dashboard button{
    padding: 10px 20px;
    border: 2px solid #007932;
    border-radius: 12px;
    background-color: white;
    cursor:pointer
}


/* -----------------------------------------------------------------------------
// COLUMNA IZQUIERDA
// ----------------------------------------------------------------------------- */
.titulo-seccion .foto-perfil{ 
  width: 100px;
  border-radius: 50%;
}

.dashboard-user .barragris{
  background-color: rgb(192, 192, 192);
  border-radius: 5px;
  height: 12px;
  overflow: hidden;
}

.dashboard-user .barracompletado{
  border-radius: 5px;
  height: 12px;
  overflow: hidden;
}

.dashboard-user .mensaje{
    gap: 10px;
    padding: 10px 30px;
    justify-content: center;
}

/* Título - texto */
.dashboard-user .titulo-seccion h1,
.dashboard-user .titulo-seccion h2,
.dashboard-user .titulo-seccion{
    font-size: 24px;
    line-height: 1;
}

/* Título - icono */
.dashboard-user .titulo-seccion svg{
    font-size: 36px;
    margin: 3px 10px 0px 0px;
}

.dashboard-user .columna-izquierda .contenido{ margin: 15px 0px; }
.dashboard-user .columna-izquierda .contenido p{ margin-bottom: 0px; }

/* botones */
.dashboard-user .columna-izquierda a, .dashboard-user .columna-izquierda button{
    padding: 6px 15px;
    border: 2px solid #007932;
    border-radius: 12px;
    background-color: white;
    color: #007932;
}

button:hover, 
.dashboard-user .columna-izquierda a:hover, 
.dashboard-user .columna-izquierda button:hover{
    color: white;
    background-color: #007932;
}

.dashboard-user .columna-izquierda .close-button{
  color: white;
  background-color: #007932;
}

.dashboard-user .columna-izquierda .close-button:hover{
  color: #007932;
  background-color: #fff;
}

.dashboard-user .boton.boton-izq{
  display: block;
  height: 39.2px;
  width: fit-content;
}


/* -----------------------------------------------------------------------------
// COLUMNA DERECHA
// ----------------------------------------------------------------------------- */
.dashboard-user .seccion-citas{margin-bottom: 60px;}


.dashboard-user .noticias{
    flex-wrap: wrap;
    margin-top: 20px;
    gap: 20px 2.5%;
    align-items: stretch;
}


.dashboard-user .noticias .noticia{
    border: 1px solid #007932;
    border-left: 12px solid #007932;
    border-radius: 20px;
    padding: 12px 25px;
    width: 23%;
}

.dashboard-user .noticias .etiqueta{
    text-align: end;
    font-size: 14px;
    font-weight: bold;
}

.dashboard-user .noticias .noticia.formacion{
    border: 1px solid #b90248;
    border-left: 12px solid #b90248;
}

.dashboard-user .noticias .noticia.social{
    border: 1px solid #3C4A99;
    border-left: 12px solid #3C4A99;
}

.dashboard-user .noticias .noticia.recurso{
  border: 1px solid #d24315;
  border-left: 12px solid #d24315;
}

.dashboard-user .noticias .noticia.recurso.social{    
  border: 1px solid #3C4A99;
  border-left: 10px solid #3C4A99;
}

.dashboard-user .noticias .noticia a:hover{ cursor: pointer; }

.azul{ color: #3C4A99;}
.rosa{ color: #b90248;}
.naranja{ color: #d24315;}

.boton.rosa{ border: 2px solid #b90248;}
.boton.rosa:hover{ background-color:  #b90248; color: white;}

.boton.azul{ border: 2px solid #3C4A99;}
.boton.azul:hover{ background-color:  #3C4A99; color: white;}

.boton.naranja{ border: 2px solid #d24315;}
.boton.naranja:hover{ background-color:  #d24315; color: white;}

/* -----------------------------------------------------------------------------
// VENTANA EMERGENTE - HISTÓRICO DE SEGUIMIENTO
// ----------------------------------------------------------------------------- */
.historico-seguimiento {
    position: fixed;
    top: 30px;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.842);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .modal-content {
    background: white;
    width: 50%;
    max-width: 500px;
    border-radius: 20px;
    overflow: hidden;
  }
  
  .modal-header {
    background: #007932;
    color: white;
    padding: 5px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .modal-header h2 {
    display: flex;
    align-items: center;
    gap: 10px;
    line-height: 1.1;
    margin-left: 15px;
  }

  .modal-header h2 svg{font-size: 28px;}
  
  .close-button {
    background-color: #007932;
    border: none;
    color: #007932;
    font-size: 1.5rem;
    cursor: pointer;
    padding: 0px 10px;
  }

  .close-button:hover{
    background-color: white;
    color: #007932;
  }

  .modal-body {
    padding: 7.5px 25px 20px 25px;
    max-height: 400px; /* Altura máxima del modal antes de hacer scroll */
    overflow-y: auto;
  }
  
  .modal-body th, .modal-body td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #ddd;
  }
  
  .modal-body table { border-collapse: collapse; }
  .no-scroll { overflow: hidden; }

  /* Estilo del scroll */
.modal-body::-webkit-scrollbar { width: 8px; }

.modal-body::-webkit-scrollbar-thumb {
  background-color: #c2c2c2;
  border-radius: 4px;
}

.modal-body::-webkit-scrollbar-track { background: #f1f1f1; }


.solicita-cita button:hover{
    background-color: #007932;
    color: white;
}

.dashboard-user .modal-body select,
.dashboard-user .modal-body input{
  border: none;
  border-bottom: 1px solid #007932;
  outline: none;
}

.dashboard-admin .empleo-destacado{
  margin-top: 0;
}

.dashboard-user .modal-body textarea{
  border: 1px solid #007932;
  border-radius: 15px;
  outline: none;
  padding: 5px 10px;
}

.mensaje-exito {
  background-color: #d4edda;
  border-radius: 8px;
}

.mensaje-exito p{
  color: #155724;
  padding: 25px;
  font-weight: bold;
  text-align: center;
}

.dashboard-user .cita-social .modal-header{ 
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
}

.dashboard-user .cita-social form{ 
  padding: 25px; 
  background-color: white;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
}


.dashboard-user .cita-social .campo{ border-bottom: 1px solid #007932; }
.dashboard-user .cita-social .boton:hover{ border: 2px solid white; }
.dashboard-user .cita-social .close-button{background-color: #007932;}
.dashboard-user .cita-social .close-button:hover{color: #007932; background-color: white;}

.dashboard-user .cita-social textarea,
.cita-social textarea{ 
  border: 1px solid #007932; 
  border-radius: 10px;
  padding: 5px 10px;
}

.cita-social textarea{ border: 1px solid #3C4A99; }`, "",{"version":3,"sources":["webpack://./src/pages/user/css/Dashboard.css"],"names":[],"mappings":"AAAA,iBAAiB,6BAA6B,EAAE;;;AAGhD,yBAAyB,WAAW,EAAE;;AAEtC;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;;AAGA;;kFAEkF;AAClF;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA,mBAAmB;AACnB;;;IAGI,eAAe;IACf,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA,+CAA+C,gBAAgB,EAAE;AACjE,iDAAiD,kBAAkB,EAAE;;AAErE,YAAY;AACZ;IACI,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;;;IAGI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;;AAGA;;kFAEkF;AAClF,+BAA+B,mBAAmB,CAAC;;;AAGnD;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;AACxB;;;AAGA;IACI,yBAAyB;IACzB,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA,4CAA4C,eAAe,EAAE;;AAE7D,OAAO,cAAc,CAAC;AACtB,OAAO,cAAc,CAAC;AACtB,UAAU,cAAc,CAAC;;AAEzB,aAAa,yBAAyB,CAAC;AACvC,mBAAmB,0BAA0B,EAAE,YAAY,CAAC;;AAE5D,aAAa,yBAAyB,CAAC;AACvC,mBAAmB,0BAA0B,EAAE,YAAY,CAAC;;AAE5D,gBAAgB,yBAAyB,CAAC;AAC1C,sBAAsB,0BAA0B,EAAE,YAAY,CAAC;;AAE/D;;kFAEkF;AAClF;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,qBAAqB,eAAe,CAAC;;EAErC;IACE,yBAAyB;IACzB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,6BAA6B;IAC7B,iBAAiB,EAAE,kDAAkD;IACrE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA,oBAAoB,yBAAyB,EAAE;EAC/C,aAAa,gBAAgB,EAAE;;EAE/B,sBAAsB;AACxB,iCAAiC,UAAU,EAAE;;AAE7C;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,uCAAuC,mBAAmB,EAAE;;;AAG5D;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;;EAEE,YAAY;EACZ,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gCAAgC;EAChC,+BAA+B;AACjC;;;AAGA,qCAAqC,gCAAgC,EAAE;AACvE,2CAA2C,uBAAuB,EAAE;AACpE,2CAA2C,yBAAyB,CAAC;AACrE,iDAAiD,cAAc,EAAE,uBAAuB,CAAC;;AAEzF;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,uBAAuB,yBAAyB,EAAE","sourcesContent":[".dashboard-user{ margin: 130px 80px 100px 80px; }\n\n\n.dashboard-user section{ margin: 0px; }\n\n.dashboard button{\n    padding: 10px 20px;\n    border: 2px solid #007932;\n    border-radius: 12px;\n    background-color: white;\n    cursor:pointer\n}\n\n\n/* -----------------------------------------------------------------------------\n// COLUMNA IZQUIERDA\n// ----------------------------------------------------------------------------- */\n.titulo-seccion .foto-perfil{ \n  width: 100px;\n  border-radius: 50%;\n}\n\n.dashboard-user .barragris{\n  background-color: rgb(192, 192, 192);\n  border-radius: 5px;\n  height: 12px;\n  overflow: hidden;\n}\n\n.dashboard-user .barracompletado{\n  border-radius: 5px;\n  height: 12px;\n  overflow: hidden;\n}\n\n.dashboard-user .mensaje{\n    gap: 10px;\n    padding: 10px 30px;\n    justify-content: center;\n}\n\n/* Título - texto */\n.dashboard-user .titulo-seccion h1,\n.dashboard-user .titulo-seccion h2,\n.dashboard-user .titulo-seccion{\n    font-size: 24px;\n    line-height: 1;\n}\n\n/* Título - icono */\n.dashboard-user .titulo-seccion svg{\n    font-size: 36px;\n    margin: 3px 10px 0px 0px;\n}\n\n.dashboard-user .columna-izquierda .contenido{ margin: 15px 0px; }\n.dashboard-user .columna-izquierda .contenido p{ margin-bottom: 0px; }\n\n/* botones */\n.dashboard-user .columna-izquierda a, .dashboard-user .columna-izquierda button{\n    padding: 6px 15px;\n    border: 2px solid #007932;\n    border-radius: 12px;\n    background-color: white;\n    color: #007932;\n}\n\nbutton:hover, \n.dashboard-user .columna-izquierda a:hover, \n.dashboard-user .columna-izquierda button:hover{\n    color: white;\n    background-color: #007932;\n}\n\n.dashboard-user .columna-izquierda .close-button{\n  color: white;\n  background-color: #007932;\n}\n\n.dashboard-user .columna-izquierda .close-button:hover{\n  color: #007932;\n  background-color: #fff;\n}\n\n.dashboard-user .boton.boton-izq{\n  display: block;\n  height: 39.2px;\n  width: fit-content;\n}\n\n\n/* -----------------------------------------------------------------------------\n// COLUMNA DERECHA\n// ----------------------------------------------------------------------------- */\n.dashboard-user .seccion-citas{margin-bottom: 60px;}\n\n\n.dashboard-user .noticias{\n    flex-wrap: wrap;\n    margin-top: 20px;\n    gap: 20px 2.5%;\n    align-items: stretch;\n}\n\n\n.dashboard-user .noticias .noticia{\n    border: 1px solid #007932;\n    border-left: 12px solid #007932;\n    border-radius: 20px;\n    padding: 12px 25px;\n    width: 23%;\n}\n\n.dashboard-user .noticias .etiqueta{\n    text-align: end;\n    font-size: 14px;\n    font-weight: bold;\n}\n\n.dashboard-user .noticias .noticia.formacion{\n    border: 1px solid #b90248;\n    border-left: 12px solid #b90248;\n}\n\n.dashboard-user .noticias .noticia.social{\n    border: 1px solid #3C4A99;\n    border-left: 12px solid #3C4A99;\n}\n\n.dashboard-user .noticias .noticia.recurso{\n  border: 1px solid #d24315;\n  border-left: 12px solid #d24315;\n}\n\n.dashboard-user .noticias .noticia.recurso.social{    \n  border: 1px solid #3C4A99;\n  border-left: 10px solid #3C4A99;\n}\n\n.dashboard-user .noticias .noticia a:hover{ cursor: pointer; }\n\n.azul{ color: #3C4A99;}\n.rosa{ color: #b90248;}\n.naranja{ color: #d24315;}\n\n.boton.rosa{ border: 2px solid #b90248;}\n.boton.rosa:hover{ background-color:  #b90248; color: white;}\n\n.boton.azul{ border: 2px solid #3C4A99;}\n.boton.azul:hover{ background-color:  #3C4A99; color: white;}\n\n.boton.naranja{ border: 2px solid #d24315;}\n.boton.naranja:hover{ background-color:  #d24315; color: white;}\n\n/* -----------------------------------------------------------------------------\n// VENTANA EMERGENTE - HISTÓRICO DE SEGUIMIENTO\n// ----------------------------------------------------------------------------- */\n.historico-seguimiento {\n    position: fixed;\n    top: 30px;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.842);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n  }\n  \n  .modal-content {\n    background: white;\n    width: 50%;\n    max-width: 500px;\n    border-radius: 20px;\n    overflow: hidden;\n  }\n  \n  .modal-header {\n    background: #007932;\n    color: white;\n    padding: 5px 15px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .modal-header h2 {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    line-height: 1.1;\n    margin-left: 15px;\n  }\n\n  .modal-header h2 svg{font-size: 28px;}\n  \n  .close-button {\n    background-color: #007932;\n    border: none;\n    color: #007932;\n    font-size: 1.5rem;\n    cursor: pointer;\n    padding: 0px 10px;\n  }\n\n  .close-button:hover{\n    background-color: white;\n    color: #007932;\n  }\n\n  .modal-body {\n    padding: 7.5px 25px 20px 25px;\n    max-height: 400px; /* Altura máxima del modal antes de hacer scroll */\n    overflow-y: auto;\n  }\n  \n  .modal-body th, .modal-body td {\n    padding: 10px;\n    text-align: left;\n    border-bottom: 1px solid #ddd;\n  }\n  \n  .modal-body table { border-collapse: collapse; }\n  .no-scroll { overflow: hidden; }\n\n  /* Estilo del scroll */\n.modal-body::-webkit-scrollbar { width: 8px; }\n\n.modal-body::-webkit-scrollbar-thumb {\n  background-color: #c2c2c2;\n  border-radius: 4px;\n}\n\n.modal-body::-webkit-scrollbar-track { background: #f1f1f1; }\n\n\n.solicita-cita button:hover{\n    background-color: #007932;\n    color: white;\n}\n\n.dashboard-user .modal-body select,\n.dashboard-user .modal-body input{\n  border: none;\n  border-bottom: 1px solid #007932;\n  outline: none;\n}\n\n.dashboard-admin .empleo-destacado{\n  margin-top: 0;\n}\n\n.dashboard-user .modal-body textarea{\n  border: 1px solid #007932;\n  border-radius: 15px;\n  outline: none;\n  padding: 5px 10px;\n}\n\n.mensaje-exito {\n  background-color: #d4edda;\n  border-radius: 8px;\n}\n\n.mensaje-exito p{\n  color: #155724;\n  padding: 25px;\n  font-weight: bold;\n  text-align: center;\n}\n\n.dashboard-user .cita-social .modal-header{ \n  border-top-right-radius: 20px;\n  border-top-left-radius: 20px;\n}\n\n.dashboard-user .cita-social form{ \n  padding: 25px; \n  background-color: white;\n  border-bottom-right-radius: 20px;\n  border-bottom-left-radius: 20px;\n}\n\n\n.dashboard-user .cita-social .campo{ border-bottom: 1px solid #007932; }\n.dashboard-user .cita-social .boton:hover{ border: 2px solid white; }\n.dashboard-user .cita-social .close-button{background-color: #007932;}\n.dashboard-user .cita-social .close-button:hover{color: #007932; background-color: white;}\n\n.dashboard-user .cita-social textarea,\n.cita-social textarea{ \n  border: 1px solid #007932; \n  border-radius: 10px;\n  padding: 5px 10px;\n}\n\n.cita-social textarea{ border: 1px solid #3C4A99; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
